import React from 'react';
import PropTypes from 'prop-types';
import {components} from 'react-select';

export const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <span className="Select-arrow" />
      </components.DropdownIndicator>
    )
  );
};

DropdownIndicator.propTypes = {
  props: PropTypes.object
};

export default DropdownIndicator;
